var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { ChevronDown } from '../icon';
import { selectWrapperStyle, selectStyle, iconRightStyle } from './styles';
function SelectInternal(_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.inverted, inverted = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.error, error = _e === void 0 ? false : _e, children = _a.children, value = _a.value, onFocus = _a.onFocus, onBlur = _a.onBlur, restProps = __rest(_a, ["size", "inverted", "disabled", "error", "children", "value", "onFocus", "onBlur"]);
    var _f = __read(useState(false), 2), isFocused = _f[0], setIsFocused = _f[1];
    function handleFocus(event) {
        if (onFocus) {
            onFocus(event);
        }
        setIsFocused(true);
    }
    function handleBlur(event) {
        if (onBlur) {
            onBlur(event);
        }
        setIsFocused(false);
    }
    return (_jsxs("div", __assign({ css: selectWrapperStyle({ size: size, disabled: disabled, isFocused: isFocused }) }, { children: [_jsx("select", __assign({}, restProps, { value: value, disabled: disabled }, { ref: ref, onFocus: handleFocus, onBlur: handleBlur, "aria-invalid": error, css: selectStyle({
                    hasError: error,
                    withPlaceholder: value === '' || value === 'placeholder',
                    size: size,
                    inverted: inverted,
                }) }, { children: children })), _jsx("div", __assign({ css: iconRightStyle({ size: size, inverted: inverted }) }, { children: _jsx(ChevronDown, { size: size === 'large' ? 'medium' : size }) }))] })));
}
export default SelectInternal;
